"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParallelRequestManager = void 0;
class ParallelRequestManager {
    constructor() {
        this.createPendingRequestsKey = (url, body) => {
            let key = `${url}`;
            if (body) {
                const sortedBodyKeys = Object.keys(body).sort();
                const sortedBody = sortedBodyKeys.reduce((obj, key) => {
                    obj[key] = body[key];
                    return obj;
                }, {});
                key += `:${JSON.stringify(sortedBody)}`;
            }
            return key;
        };
        this.handleRequest = (fetchFn, urlRaw, xhrOptions) => __awaiter(this, void 0, void 0, function* () {
            const key = this.createPendingRequestsKey(urlRaw, xhrOptions === null || xhrOptions === void 0 ? void 0 : xhrOptions.params);
            if (this.pendingRequests.has(key)) {
                return this.pendingRequests.get(key);
            }
            const requestPromise = (() => __awaiter(this, void 0, void 0, function* () {
                const response = yield fetchFn();
                this.pendingRequests.delete(key);
                return response;
            }))();
            this.pendingRequests.set(key, requestPromise);
            return requestPromise;
        });
        this.pendingRequests = new Map();
    }
}
exports.ParallelRequestManager = ParallelRequestManager;
//# sourceMappingURL=ParallelRequestManager.js.map